(function () {
  if (customElements.get('amb-carousel-bb')) return;

  class AmbCarouselBB extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.amb-track');
      this.dotsWrap = this.querySelector('.amb-dots');
      this.prevBtn = this.querySelector('.amb-nav-prev');
      this.nextBtn = this.querySelector('.amb-nav-next');
      if (!this.track || !this.dotsWrap) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.cardsPerView = 1;
      this.totalPages = 1;
      this.currentPage = 0;
      this.dots = [];

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.goToPage(this.currentPage - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.goToPage(this.currentPage + 1));

      let scrollTimer = null;
      this.track.addEventListener('scroll', () => {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => this.updateActiveDot(), 100);
      });

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { this.buildDots(); this.currentPage = 0; }, 150);
      });

      this.buildDots();
    }

    computeCardsPerView() {
      const w = window.innerWidth;
      if (w >= 1024) return 4;
      if (w >= 640) return 2;
      return 1;
    }

    pageWidth() {
      const first = this.track.children[0];
      if (!first) return this.track.clientWidth;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      return (first.getBoundingClientRect().width + gap) * this.cardsPerView;
    }

    buildDots() {
      this.cardsPerView = this.computeCardsPerView();
      this.totalPages = Math.max(1, Math.ceil(this.track.children.length / this.cardsPerView));
      this.dotsWrap.innerHTML = '';
      this.dots = [];
      for (let i = 0; i < this.totalPages; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'amb-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Go to ambassadors page ' + (i + 1));
        d.addEventListener('click', () => this.goToPage(i));
        this.dotsWrap.appendChild(d);
        this.dots.push(d);
      }
      if (this.prevBtn) this.prevBtn.disabled = this.totalPages <= 1;
      if (this.nextBtn) this.nextBtn.disabled = this.totalPages <= 1;
    }

    updateActiveDot() {
      const page = Math.round(this.track.scrollLeft / this.pageWidth());
      if (page === this.currentPage) return;
      this.currentPage = page;
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.currentPage));
      if (this.prevBtn) this.prevBtn.disabled = this.currentPage <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentPage >= this.totalPages - 1;
    }

    goToPage(i) {
      this.currentPage = Math.max(0, Math.min(this.totalPages - 1, i));
      this.track.scrollTo({ left: this.currentPage * this.pageWidth(), behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.currentPage));
      if (this.prevBtn) this.prevBtn.disabled = this.currentPage <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentPage >= this.totalPages - 1;
    }
  }

  customElements.define('amb-carousel-bb', AmbCarouselBB);
})();
